import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHead from "../../components/Griya/PageHead";
import DonutChart from "../../components/Griya/Home/DonutChart";
import { Row, Col, Card } from "react-bootstrap";
import BarChart from "../../components/charts/rechart/BarChart";
import LineChart from "../../components/charts/rechart/LineChart";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { dashboardActions } from "../../../_store";
import { fNumber } from "../../../utils/formatNumber";

const Dashboard = () => {
  const dispatch = useDispatch();

  // #region ------------------  Reducer --------------------------------

  const dashboardList = useSelector((x) => x.dashboard.dashboardList);
  const isLoading = useSelector((x) => x.dashboard.isLoading);
  // #endregion ------------------  Reducer End --------------------------------

  const [barChartSalesData, setBarChartSalesData] = useState([]);
  const [barChartProductData, setBarChartProductData] = useState([]);
  const [barChartOrderStatusData, setBarChartOrderStatusData] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  useEffect(() => {
    if (localStorage.getItem("filterValues")) {
      localStorage.removeItem("filterValues");
    }
    dispatch(dashboardActions.getDashboardList());
  }, []);

  useEffect(() => {
    showLoader();
    if (dashboardList) {
      // let OrderCreated = [];
      let DispatchedData = [];
      let CancelledData = [];
      let ProductCreatedData = [];
      let TodayOrderStatusData = [];
      let Monthly = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let OrderStatus = ["Order Status"];

      //Monthly Sales Report
      if (
        dashboardList?.OrderDispatchedValList &&
        dashboardList.OrderCancelledValList
      ) {
        // OrderCreated = Array.from(dashboardList.OrderCreatedValList.split(","), Number);
        DispatchedData = Array.from(
          dashboardList.OrderDispatchedValList?.split(","),
          Number,
        );
        CancelledData = Array.from(
          dashboardList.OrderCancelledValList?.split(","),
          Number,
        );
      }
      const salesData = {
        labels: Monthly,
        datasets: [
          // {
          //     label: "Order Created", data: OrderCreated, backgroundColor: "#2858a5",
          // },
          {
            label: "Order Dispatched",
            data: DispatchedData,
            backgroundColor: "#88bd23",
          },
          {
            label: "Order Cancelled",
            data: CancelledData,
            backgroundColor: "#e41b12",
          },
        ],
      };

      //Monthly Product Report
      if (dashboardList.ProductCreatedValList) {
        ProductCreatedData = Array.from(
          dashboardList.ProductCreatedValList.split(","),
          Number,
        );
      }
      const productData = {
        labels: Monthly,
        datasets: [
          {
            label: "Product Created",
            data: ProductCreatedData,
            backgroundColor: "#2858a5",
          },
        ],
      };

      //Today Order Status Report
      if (dashboardList.TodayOrderStatusValList) {
        TodayOrderStatusData = Array.from(
          dashboardList.TodayOrderStatusValList.split(","),
          Number,
        );
      }
      const orderStatusData = {
        labels: OrderStatus,
        datasets: [
          {
            label: "Order Created",
            data: [TodayOrderStatusData && TodayOrderStatusData[0]],
            backgroundColor: "#2858a5",
          },
          {
            label: "Order Assigned",
            data: [TodayOrderStatusData && TodayOrderStatusData[1]],
            backgroundColor: "#01b5e5",
          },
          {
            label: "Order Prepared",
            data: [TodayOrderStatusData && TodayOrderStatusData[2]],
            backgroundColor: "#ed8b00",
          },
          {
            label: "Invoice Sent",
            data: [TodayOrderStatusData && TodayOrderStatusData[3]],
            backgroundColor: "#edb15b",
          },
          {
            label: "Payment Received",
            data: [TodayOrderStatusData && TodayOrderStatusData[4]],
            backgroundColor: "#88bd23",
          },
          {
            label: "Ready to Dispatch",
            data: [TodayOrderStatusData && TodayOrderStatusData[5]],
            backgroundColor: "#e50a7e",
          },
          {
            label: "Order Dispatched",
            data: [TodayOrderStatusData && TodayOrderStatusData[6]],
            backgroundColor: "#48A23F",
          },
          {
            label: "Order Cancelled",
            data: [TodayOrderStatusData && TodayOrderStatusData[7]],
            backgroundColor: "#e42313",
          },
        ],
      };

      setBarChartSalesData(salesData);
      setBarChartProductData(productData);
      setBarChartOrderStatusData(orderStatusData);
    }
  }, [dashboardList]);
  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  return (
    <>
      <PageHead activePage="Dashboard" pageName="Main Dashboard" />

      <div className="row">
        <div className="col-xl-3 col-sm-6">
          <div className="card">
            <div className="card-body  d-flex align-items-center justify-content-between">
              <div className="card-data me-2">
                <h5>Total Inventory</h5>
                <h2 className="fs-40 font-w600">
                  {fNumber(dashboardList?.TotalInventory)}
                </h2>
              </div>
              <DonutChart
                value={dashboardList?.TotalInventory}
                backgroundColor="#2858a5"
                backgroundColor2="rgba(242, 246, 252)"
              />
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6">
          <div className="card">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="card-data me-2">
                <h5>Out of Stock</h5>
                <h2 className="fs-40 font-w600">{dashboardList?.OutofStock}</h2>
              </div>
              <DonutChart
                value={dashboardList?.OutofStock}
                backgroundColor="#e42313"
                backgroundColor2="rgba(242, 246, 252)"
              />
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6">
          <div className="card">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="card-data me-2">
                <h5>Order Prepared</h5>
                <h2 className="fs-40 font-w600">
                  {dashboardList?.OrdersPacked}
                </h2>
              </div>
              <DonutChart
                value={dashboardList?.OrdersPacked}
                backgroundColor="#fab600"
                backgroundColor2="rgba(242, 246, 252)"
              />
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6">
          <div className="card">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="card-data me-2">
                <h5>Order Dispatched</h5>
                <h2 className="fs-40 font-w600">
                  {fNumber(dashboardList?.OrdersDispatched)}
                </h2>
              </div>
              <DonutChart
                value={dashboardList?.OrdersDispatched}
                backgroundColor="#48a23f"
                backgroundColor2="rgba(242, 246, 252)"
              />
            </div>
          </div>
        </div>
      </div>

      <Row>
        <Col xl={6} lg={6}>
          <Card>
            <Card.Header>
              <h4 className="card-title">Dispatched vs Cancelled</h4>
            </Card.Header>
            <Card.Body>
              {barChartSalesData && <BarChart chartData={barChartSalesData} />}
            </Card.Body>
          </Card>
        </Col>
        <Col xl={6} lg={6}>
          <Card>
            <Card.Header>
              <h4 className="card-title">Monthly Product Report</h4>
            </Card.Header>
            <Card.Body>
              {barChartProductData && (
                <BarChart chartData={barChartProductData} />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xl={6} lg={6}>
          <Card>
            <Card.Header>
              <h4 className="card-title">Today Order Status</h4>
            </Card.Header>
            <Card.Body>
              {barChartOrderStatusData && (
                <BarChart chartData={barChartOrderStatusData} />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xl={6} lg={6}>
          <Card>
            <Card.Header>
              <h4 className="card-title">Orders processed </h4>
            </Card.Header>
            <Card.Body>
              {barChartSalesData && <LineChart chartData={barChartSalesData} />}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loader}
    </>
  );
};
export default Dashboard;
